
import { useTranslation } from 'react-i18next'
import { useFormatCurrency, useProductPrice } from '@ten24/slatwall-storefront-react-private/global'
import { Link } from 'react-router-dom'
import { isAuthenticated } from '@ten24/slatwall-storefront-react-private/global'
import { useSelector } from 'react-redux'

const ProductPrice = ({ salePrice = 0, listPrice = 0, type = 'product', showPriceForUserType = 'All', ignoreDisplayRules = false, salePriceSuffixKey, accentSalePrice = true, listPriceSuffixKey = 'frontend.core.list' }) => {
  const [formatCurrency] = useFormatCurrency({})
  const theme = useSelector(state => state.configuration.site.theme)

  const { t } = useTranslation()
  const { showMissingPrice, showSalePrice, showListPrice, isActionRequiredToShowPrice } = useProductPrice({ salePrice, listPrice, type, showPriceForUserType, ignoreDisplayRules })
  return (
    <>
      <div className="product-price">
        {showMissingPrice && <strong>{theme.noPriceText}</strong>}
        {showListPrice &&
          showPriceForUserType === "All" && ( // show list price only when list price is more than sale price
            <small className="d-flex align-items-center">
              <p className="price-text me-1 mb-0"> {t("frontend.msrp")} </p>
              <s>{`${formatCurrency(listPrice)}`}</s>
            </small>
          )}
        <div className="d-flex align-items-center flex-wrap">
          {showSalePrice && (
            <span className="d-flex align-items-center me-2">
              <p className="m-0 price-text">Pack Sizing / UOM</p>
            </span>
          )}
          <b className="m-0">{formatCurrency(salePrice)} each</b>
        </div>
      </div>
      {(isActionRequiredToShowPrice &&
        showPriceForUserType === "Authenticated") ||
        (!isAuthenticated() &&
          isActionRequiredToShowPrice &&
          showPriceForUserType === "Verified" && (
            <div className="alert alert-warning fs-6" role="alert">
              {t("frontend.product.loginToView")}
              <br />
              <Link to="/my-account/login">
                {" "}
                {t("frontend.account.login")}{" "}
              </Link>
            </div>
          ))}
      {isAuthenticated() &&
        isActionRequiredToShowPrice &&
        showPriceForUserType === "Verified" && (
          <div className="alert alert-warning fs-6" role="alert">
            {t("frontend.product.verifyForPricing")}
          </div>
        )}
    </>
  );
};

export { ProductPrice };
